import {useMerchant} from '../../hooks';
import {Fragment, useState} from 'react';
import {Spinner} from '../../components';
import {MerchantForm, MerchantDialog} from './ui';

export const MerchantPage = () => {
  const merchant = useMerchant();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
      <Fragment>
          <h1 className="mb-4 text-4xl w-4/5 text-brand-6 font-bold flex justify-between">
              <span>Merchant</span>
              <button
                  className="flex flex-center h-10 p-2 text-white active:bg-brand-1/25 rounded-lg text-sm bg-brand-1 "
                  onClick={() => setIsDialogOpen(true)}>
                  New Merchant
              </button>
          </h1>
          <div className="p-7 w-4/5 bg-white rounded-3xl h-full relative">
              {merchant
                  ? <MerchantForm merchant={merchant}/>
                  : <Spinner/>
              }
          </div>
          {isDialogOpen && <MerchantDialog isOpen={isDialogOpen} onClose={() => setIsDialogOpen(false)}/>}
      </Fragment>
  );
};

